import { Link, useLocation } from "react-router-dom";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function NotFound() {
  const location = useLocation();

  usePageMeta({
    title: "页面走丢了 - 黑料吃瓜",
    description: "这个页面可能已被移除或地址有误，返回黑料吃瓜首页继续浏览最新娱乐八卦与明星黑料。",
    keywords: "404,页面不存在,黑料吃瓜,娱乐八卦",
  });

  return (
    <div className="max-w-[1320px] mx-auto px-4 md:px-6 py-20 md:py-24 text-center">
      <p className="font-heading text-5xl md:text-6xl font-black text-background-300 select-none">404</p>
      <h1 className="font-heading text-2xl md:text-3xl font-black text-foreground-950 mt-3">这个瓜，我们没找到</h1>
      <p className="text-[13.5px] text-foreground-500 mt-2">
        页面可能已被移除或地址有误：{location.pathname}
      </p>
      <div className="flex flex-wrap justify-center gap-3 mt-7">
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 px-5 h-10 rounded-md bg-primary-500 text-background-50 text-sm whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
        >
          <i className="ri-home-4-line" />
          回到首页
        </Link>
        <Link
          to="/search"
          className="inline-flex items-center gap-1.5 px-5 h-10 rounded-md border border-background-300 text-foreground-700 text-sm whitespace-nowrap hover:border-primary-300 hover:text-primary-700 transition-colors cursor-pointer"
        >
          <i className="ri-search-line" />
          站内搜索
        </Link>
      </div>
    </div>
  );
}